import React, { Fragment } from "react";
import RegistrationForm from "./Pages/registration/RegistrationForm";

const App = () => {
  return (
    <Fragment>
      <RegistrationForm />
    </Fragment>
  );
};

export default App;
